exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.dropdown-toggle[data-v-044fffa0] {\n  max-width: 100%;\n  overflow: auto;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-044fffa0","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ISCOSelectorModal.vue
// module id = s2ZL
// module chunks = 97